
function isGlyphSupported(font, glyph) {
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  const size = '48px';

  ctx.font = `${size} '${font}', 'AbBlank', sans-serif`;
  const testWidth = ctx.measureText(glyph).width;

  return testWidth > 0;
}

const excludedChars = ['*', '(', ')', '”', '{', '}', '+', '%', '“'];

function collectUniqueChars(obj) {
  const charSet = new Set();

  function traverse(current) {
    for (const key in current) {
      if (current.hasOwnProperty(key)) {
        const value = current[key];
        if (typeof value === 'string') {
          for (const char of value) {
            charSet.add(char);
          }
        } else if (typeof value === 'object' && value !== null) {
          traverse(value);
        }
      }
    }
  }

  traverse(obj);
  return Array.from(charSet);
}

function getUnsupportedGlyphsInLocalizationObjectByFonts(obj, fonts = []) { // obj = OPWrapperService.localizations.localization, fonts = preloaderConfig.fonts
  let uniqueChars = collectUniqueChars(obj);
  uniqueChars = uniqueChars.filter(char => !excludedChars.includes(char));
  const unsupportedCharsData = {};

  fonts.forEach(fontData => {
    unsupportedCharsData[fontData.name] = [];
    uniqueChars.forEach(char => {
      if (!isGlyphSupported(fontData.name, char)) {
        unsupportedCharsData[fontData.name].push(char);
      }
    });
  })

  return unsupportedCharsData;
}


export {
  getUnsupportedGlyphsInLocalizationObjectByFonts
}
